import React, { useState, useEffect } from "react";

const ResendValidity = ({ time = 10, onTimerEnd }) => {
  const [timeLeft, setTimeLeft] = useState();

  useEffect(() => {
    setTimeLeft(time)
  }, [time])
  

  useEffect(() => {
    if (timeLeft <= 0) {
      if (onTimerEnd) onTimerEnd(); 
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          if (onTimerEnd) onTimerEnd();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]); // depends on timeLeft

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <div className="flex justify-center items-center w-full">
       <div className="timer bg-[#272727] text-white text-sm inline-block mx-auto px-[1rem] py-[5px] rounded-[30px]">
        {timeLeft ?  "Validity :" +formatTime(timeLeft) : <><span className="font-bold">OTP Expired!</span>  Please resend OTP</>}
      </div> 
    </div>
  );
};

export default ResendValidity;
